import React, { useRef } from 'react';
import clsx from 'clsx';

import { AggregateType } from 'modules/redux/states/policy/scores/constants';
import { FontSize, Padding } from 'components/Card/constants';
import { ReactComponent as SpinnerSVG } from 'modules/theme/images/icons/spinners/circular-bars.svg';
import Buttons from '../Buttons';
import Card from 'components/Card';

import chartStyles from '../styles.module.scss';
import styles from './styles.module.scss';

const Skeleton: React.FunctionComponent = () => {
  const ref = useRef<HTMLElement>(null);

  const classNames = clsx(chartStyles.charts, styles.skeleton);
  return (
    <Card
      className={classNames}
      fontSize={FontSize.LARGE}
      forwardedRef={ref}
      padding={Padding.LARGE}
      renderHeader={() => (
        <Buttons aggregateType={AggregateType.MONTHLY} isLoading={true} />
      )}
      title="Score over time">
      <span data-nosnippet className="visually-hidden">
        Loading score over time chart
      </span>
      <SpinnerSVG />
      <div className={chartStyles['chart-container']}>
        <div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </Card>
  );
};

export default React.memo(Skeleton);
